var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('customer-service',{attrs:{"content":(_vm.content),"titleKey":(_vm.question),"listKey":(_vm.answers),"phone":(_vm.actionTitle),"globalPhone":(_vm.globalPhone)}})
}
var staticRenderFns = []

export { render, staticRenderFns }